import { createSlice } from "@reduxjs/toolkit";
import * as actions from './searchActions';

const initialState = {
  searchOptions: {},
  contentResults: {},
  productResults: {},
  filterResults: {},
  defaultFilters: {},
  defaultProductFilters: {},
  searchFilters: {},
  activeFilters: [],
  searchPageData: {},
  showFilterLoading: true,
  showResultsLoading: true,
  isLoadMore: false,
  isExpandingSearch: false,
  autocompleteResults: {},
  isClearFilter: false,
  savedContentIds: [],
  getSavedContentIds: [],
  fetchPostTypePageHeading: [],
  isViewChanged: false,
}

const searchReducer = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setOptions: (state, data) => {
      state.searchOptions = data.payload
    },
    setSearchQuery: (state, data) => {
      let options = { ...state.searchOptions };
      state.searchOptions = { ...options, searchQuery: data.payload };
    },
    setSavedContentIds: (state, data) => {
      state.savedContentIds = data.payload;
    },
    setProductResults: (state, data) => {
      state.productResults = data.payload;
    },
    setSearchPageData: (state, data) => {
      state.searchPageData = data.payload;
    },
    setDefaultFilters: (state, data) => {
      state.defaultFilters = data.payload;
    },
    setDefaultProductFilters: (state, data) => {
      state.defaultProductFilters = data.payload;
    },
    setSearchFilters: (state, data) => {
      state.searchFilters = data.payload;
    },
    setActiveFilters: (state, data) => {
      state.activeFilters = data.payload;
    },
    setResultsLoading: (state, data) => {
      state.showResultsLoading = data.payload;
    },
    setFiltersLoading: (state, data) => {
      state.showFilterLoading = data.payload;
    },
    setIpAddress: (state, data) => {
      state.searchOptions = { ...state.searchOptions, ipAddress: data.payload };
    },
    setAutocompleteResults: (state, data) => {
      state.autocompleteResults = data.payload;
    },
    setIsClearFilter: (state, data) => {
      state.isClearFilter = data.payload;
    },
    setIsViewChanged: (state, data) => {
      state.isViewChanged = data.payload;
    },
    setSavedPostIds: (state, data) => {
      state.getSavedContentIds = data.payload;
    },
    setfetchPostTypePageHeading: (state, data) => {
      state.fetchPostTypePageHeading = data.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(actions.searchResult.pending, (state) => {
      const options = { ...state.searchOptions };
      if (options.loadMore) {
        state.isLoadMore = true;
      } else if (options.expandingSearch) {
        state.isExpandingSearch = true;
      } else {
        state.showResultsLoading = true;
      }
    });
      builder.addCase(actions.searchResult.fulfilled, (state, action) => {
        state.contentResults = action.payload.data;
        state.showResultsLoading = false;
      });
      builder.addCase(actions.searchResult.rejected, (state) => {
        state.showResultsLoading = false;
        state.isLoadMore = false;
        state.isExpandingSearch = false;
      });

      builder.addCase(actions.searchResultAppend.pending, (state) => {
        const options = { ...state.searchOptions };
        if (options.loadMore) {
          state.isLoadMore = true;
        } else if (options.expandingSearch) {
          state.isExpandingSearch = true;
        } else {
          state.showResultsLoading = true;
        }
      });
        builder.addCase(actions.searchResultAppend.fulfilled, (state, action) => {
          const options = { ...state.searchOptions };
          const hits = [...state.contentResults?.hits, ...action.payload.data?.hits];
          const resultData = {
            ...action.payload.data,
            hits: hits
          };
          state.contentResults = resultData;
          
          if (options.loadMore) {
            state.isLoadMore = false;
          } else if (options.expandingSearch) {
            state.isExpandingSearch = false;
          } else {
            state.showResultsLoading = false;
          }
        });
        builder.addCase(actions.searchResultAppend.rejected, (state) => {
          state.showResultsLoading = false;
          state.isLoadMore = false;
          state.isExpandingSearch = false;
        });

    builder.addCase(actions.searchFilters.pending, (state) => {
      state.showFilterLoading = true;
    });
      builder.addCase(actions.searchFilters.fulfilled, (state, action) => {
        if (action.payload.success) {
          state.searchFilters = action.payload.data;
        }
        state.showFilterLoading = false;
      });
      builder.addCase(actions.searchFilters.rejected, (state) => {
        state.showFilterLoading = false;
      });

    builder.addCase(actions.autoComplete.pending, (state) => {
      state.autocompleteLoading = true;
    });
      builder.addCase(actions.autoComplete.fulfilled, (state, action) => {
        if (action.payload.success) {
          state.autocompleteResults = action.payload.data;
        }
        state.autocompleteLoading = false;
      });
      builder.addCase(actions.autoComplete.rejected, (state) => {
        state.autocompleteLoading = false;
      });

    builder.addCase(actions.savedContentIds.fulfilled, (state, action) => {
      state.savedContentIds = action.payload.data;
    });

    builder.addCase(actions.getSavedContentIds.pending, (state) => {
    });
      builder.addCase(actions.getSavedContentIds.fulfilled, (state, action) => {
        if (action.payload.success) {
          state.getSavedContentIds = action.payload.data; // Ensure the response structure matches
        }
      });
      builder.addCase(actions.getSavedContentIds.rejected, (state) => {
        
      });

    builder.addCase(actions.fetchPostTypePageHeading.pending, (state) => {
    });
      builder.addCase(actions.fetchPostTypePageHeading.fulfilled, (state, action) => {
        if (action.payload.success) {
          state.fetchPostTypePageHeading = action.payload.post_type_page_heading;
        }
      });
      builder.addCase(actions.fetchPostTypePageHeading.rejected, (state) => {
        
      });
    
  }
});

export const {
  setOptions,
  setSearchQuery,
  setProductResults,
  setSearchPageData,
  setDefaultFilters,
  setDefaultProductFilters,
  setSearchFilters,
  setResultsLoading,
  setActiveFilters,
  setFiltersLoading,
  setIpAddress,
  setAutocompleteResults,
  setIsClearFilter,
  setSavedContentIds,
  setIsViewChanged,
  setSavedPostIds,
  setfetchPostTypePageHeading,
} = searchReducer.actions;

export default searchReducer.reducer;